module.exports = __webpack_public_path__ + "static/media/general-de-seguros-vest.81b4018b.svg";